/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from "react";

import { Favorite, ProjectProgress } from "../ProjectListPage/components";

import ProjectProgressReviewSlider from "./ProjectProgressReviewSlider";

export const generateProjectColumns = ({ onProgressUpdate }) => [
  { expander: true, show: false },
  {
    Header: <Favorite value toggleable={false} />,
    headerClassName: "flex -center-h",
    accessor: "isFavorite",
    id: "favorites",
    Cell: ({ value, row }) => <Favorite value={value} row={row} />,
    sortable: false,
    minWidth: 50,
    maxWidth: 50
  },
  {
    Header: "Name",
    accessor: "name",
    id: "name"
  },
  {
    Header: "Customer",
    accessor: "customer",
    id: "customer.name"
  },
  {
    Header: "Hourly Progress",
    headerClassName: "flex -center-h",
    accessor: "hoursConsumed",
    id: "hours_consumed",
    maxWidth: 120,
    minWidth: 120,
    Cell: ProjectProgress
  },
  {
    Header: "Project Progress",
    headerClassName: "flex -center-h",
    accessor: "progress",
    id: "percent_complete",
    minWidth: 400,
    maxWidth: 400,
    Cell: ({ value, row }) => (
      <ProjectProgressReviewSlider
        onProgressUpdate={onProgressUpdate}
        value={value}
        projectId={row._original._id}
      />
    )
  }
];
